module.exports = __webpack_public_path__ + "static/animation-services-hand-30e4fd272f30a896a60553d74ffdd937.png";